import React, { useEffect, useCallback, useState} from 'react';
import PlayheadEffect from 'effects/live/PlayheadEffect.js';
import {PLAYHEAD_EFFECT} from 'effects/live/constants.js';
import {PLAYHEAD_DIRECTION_BUTTON} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import {FORWARD} from 'constants/playhead-directions.js';
import { createSelector } from 'reselect'
import {connect} from 'react-redux';


const ICONS = {
    1: "/FORWARD_DIRECTION.png",
    2: "/REVERSE_DIRECTION.png",
    3: "/FORWARD_REVERSE_DIRECTION.png",
    4: "/BROWNIAN_DIRECTION.png",
};

const TrackDirectionButton = ({
    track,
    isSelected,
    direction,
    color}) => { 
    const onClick = useCallback(() => {
        let fx = track.liveEffects.effects.find(f => f.effect === PLAYHEAD_EFFECT);
        if (!fx) {
            // create a new playhead effect
            fx = new PlayheadEffect(track);
           track.liveEffects.addEffect(fx);
        }
        let _direction = (direction + 1)
        if (_direction > 4) {
            _direction = 1;
        }
        fx.directionParameter.set(_direction, undefined, undefined);
    }, [track, direction]);

    return (
          <div
            onClick={onClick}
        //style={isSelected ? {backgroundColor: color} : {}}
            className="playhead-direction-btn">
            <Documented element={PLAYHEAD_DIRECTION_BUTTON}>
            <img className="playhead-direction-icon" src={ICONS[direction]}/>
            </Documented>
          </div>
    );
}

const getLiveEffect = (track) => {
    return track.liveEffects.effects.find(fx => fx.effect === PLAYHEAD_EFFECT);
};

const selectors = {};

const getDirectionSelector = (track) => {
    if (track.playheadEffect) {
        return track.playheadEffect.direction;
    }
    return FORWARD;
}

const mapStateToProps = (state, props) => {
  return {
      direction: getDirectionSelector(props.track)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackDirectionButton);
